import React, { useState, useCallback, useRef, useEffect } from "react";
import DocsCards from "./DocsCards";
import useGetBlobs from "@/services/utils/useGetBlobs";

export interface IHealthcareDocumentProp {
  documents?: any[];
  handleRequestDocument: (documentID: string) => void;
  highlightId?: string | null;
}

const HealthcareDocumentBlock: React.FC<IHealthcareDocumentProp> = ({
  documents = [],
  handleRequestDocument,
  highlightId,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [animateTable, setAnimateTable] = useState(false);
  const {  handleDownloadBlob, isDownloading } = useGetBlobs();

  useEffect(() => {
    if (highlightId && documents.length > 0) {
      setAnimateTable(true);
      const timer = setTimeout(() => setAnimateTable(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [highlightId, documents.length]);

  const handleDownload = useCallback(async (uri: string, nombre: string) => {
    await handleDownloadBlob(uri, nombre);
  }, []);

  return (
    <div
      ref={containerRef}
      className={animateTable ? "highlight-table-pulse" : ""}
    >
      <style>{`
        .highlight-table-pulse {
          background-color: rgba(6, 182, 187, 0.1);
          border-radius: 8px;
          animation: tablePulse 1s infinite;
          box-shadow: 0 0 8px rgba(6, 182, 187, 0.3);
        }
        @keyframes tablePulse {
          0%   { transform: scale(1); }
          50%  { transform: scale(1.008); }
          100% { transform: scale(1); }
        }
      `}</style>

      <DocsCards
        items={documents}
        getName={(d) => d.nombre ?? ""}
        getDate={(d) => d.fecha}
        onDownload={(d) =>
          d.requiereOtp === false
            ? handleDownload(d.uri, d.nombre)
            : handleRequestDocument(d.id)
        }
        emptyMessage="No hay documentos asistenciales."
        onDownloading={(d) => isDownloading(d.uri)}
      />
    </div>
  );
};

export default HealthcareDocumentBlock;
